import { useState, useEffect } from "react";
import NavBar from "../../Nav Bar/NavBar";
import ColoredLogo from "../../assets/ColoredLogo.svg";

const AntiMoneyLaundering = () => {
  const [styles, setStyles] = useState({
    container: {
      maxHeight: "1710px",
      margin: "120px 0px 155px 0px",
    },

    h3: {
      fontSize: "32px",
      fontWeight: "700",
      lineHeight: "16px",
      textAlign: "left",
      color: "#000",
      marginBottom: "38px",
    },

    p: {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "28px",
      textAlign: "left",
    },

    h5: {
      fontSize: "24px",
      fontWeight: "700",
      lineHeight: "28px",
    },

    article: {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "28px",
      paddingBottom: "38px",
    },
  });

  useEffect(() => {
    const updateStyles = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 600) {
        setStyles((prevStyles) => ({
          ...prevStyles,
          container: {
            ...prevStyles.container,
            maxHeight: "3131px",
            margin: "132px 12px 86px 12px",
          },
          h3: {
            ...prevStyles.h3,
            fontSize: "24px",
            lineHeight: "30px",
            marginBottom: "24px",
          },
          h5: {
            ...prevStyles.h5,
            fontSize: "16px",
          },
          article: {
            ...prevStyles.article,
            fontSize: "14px",
          },
        }));
      }
      if (screenWidth <= 780) {
        setStyles((prevStyles) => ({
          ...prevStyles,
          h3: {
            ...prevStyles.h3,
            lineHeight: "30px",
          },
        }));
      }
    };

    updateStyles();
    window.addEventListener("resize", updateStyles);

    return () => window.removeEventListener("resize", updateStyles);
  }, []);

  return (
    <div>
      <NavBar linkColor="#000" logo={ColoredLogo} bg="#fff" />
      <div className="container tofSection" style={{ width: "86%" }}>
        <div style={styles.container}>
          <h3 style={styles.h3}>GiftCard8 Anti-Money Laundering Policy</h3>
          <article style={styles.article}>
            GiftCard8 is committed to combating money laundering and financial
            crime and strictly abides by Nigeria's anti-money laundering laws.
            We are committed to actively participating in the global anti-money
            laundering movement and our policies prioritize this commitment.
          </article>

          <h5 style={styles.h5}>Policies and Procedures</h5>
          <article style={styles.article}>
            Our anti-money laundering policies and internal controls help us
            follow all important regulations. We update them regularly when
            changes happen. Key components include:
          </article>

          <h5 style={styles.h5}>1. Compliance Officer</h5>
          <article style={styles.article}>
            Oversee compliance with laws and regulations. Monitor transactions
            and identify suspicious activities, Submit necessary reports to
            regulators.
            <br />
            Communicate with all stakeholders on anti-money laundering and
            counter-terrorist financing issues.
          </article>

          <h5 style={styles.h5}>2. Risk Committee</h5>
          <article style={styles.article}>
            Establish an independent risk committee that reports regularly to
            the Board.
            <br />
            Manage money laundering and terrorist financing risks using a
            risk-based approach.
            <br />
            Comply with the Money Laundering (Prohibition) Act 2011 and related
            regulations.
          </article>

          <h5 style={styles.h5}>3. Internal Controls</h5>
          <article style={styles.article}>
            Implement effective procedures to prevent money laundering and
            terrorist financing.
            <br />
            Ensure compliance with all legal obligations.
          </article>

          <h5 style={styles.h5}>4. Know Your Customer (KYC)</h5>
          <article style={styles.article}>
            Establish a risk-based approach to customer due diligence.
            <br />
            Collect and verify customer information, use tokens and OTP for
            security verification.
            <br />
            Perform enhanced due diligence for high-risk customers.
          </article>

          <h5 style={styles.h5}>5. Suspicious Transaction Reporting</h5>
          <article style={styles.article}>
            Identify and report any transactions that attempt to evade reporting
            requirements.
            <br />
            Pay attention to transactions with inconsistent identification or
            involving crimes.
            <br />
            Act against entities related to terrorism.
          </article>

          <h5 style={styles.h5}>6. Training and Awareness</h5>
          <article style={styles.article}>
            Provide anti-money laundering training to employees and improve
            compliance awareness.
            <br />
            Ensure that you remit all settlement proceeds to verified bank
            accounts only.
            <br />
            GiftCard8 will keep working hard to make sure the platform is secure
            and follows the rules. This helps prevent money
            laundering activities.
          </article>
        </div>
      </div>
    </div>
  );
};

export default AntiMoneyLaundering;
